/** Binary KB / MB / GB (1024-based), matching labels in UI and markdown. */
const BYTES_PER_KB = 1024;
const BYTES_PER_MB = BYTES_PER_KB * BYTES_PER_KB;
const BYTES_PER_GB = BYTES_PER_MB * BYTES_PER_KB;

/**
 * Formats a byte length using binary units (1024-based): B, KB, MB, or GB, one decimal for scaled values.
 *
 * @param bytes - Size in bytes, or null/undefined when unknown
 * @returns Formatted string (e.g. `512 B`, `1.5 MB`, `2.0 GB`), or `''` when `bytes` is nullish
 */
export function formatBinaryFileSize (bytes: number | null | undefined): string {
    if (bytes == null) {
        return '';
    }
    if (bytes < BYTES_PER_KB) {
        return `${bytes} B`;
    }
    if (bytes < BYTES_PER_MB) {
        return `${(bytes / BYTES_PER_KB).toFixed(1)} KB`;
    }
    if (bytes < BYTES_PER_GB) {
        return `${(bytes / BYTES_PER_MB).toFixed(1)} MB`;
    }

    return `${(bytes / BYTES_PER_GB).toFixed(1)} GB`;
}
